import {defineStore} from 'pinia'
import {Helpers} from "@/helpers";

export const useClientStore = defineStore({
  // name of the store
  // it is used in devtools and allows restoring state
  id: 'client',
  // a function that returns a fresh state
  state: () => ({
    serverOptions: {
      page: 0,
      rows: 20,
      filters: {},
    },
  }),
  // optional getters
  getters: {},
  // optional actions
  actions: {
    async apiIndex() {
      let params = {
        page: this.serverOptions.page + 1,
        size: this.serverOptions.rows
      }
      let filters = {}
      if (this.serverOptions.filters.name?.value) {
        filters['name'] = this.serverOptions.filters.name.value
      } else {
        await Helpers.removeQueryFromUrl("name")
      }
      if (this.serverOptions.filters.filter_kdnr?.value) {
        filters['filter_kdnr'] = this.serverOptions.filters.filter_kdnr.value
      } else {
        await Helpers.removeQueryFromUrl("filter_kdnr")
      }
      await Helpers.addQueryToParams(filters, params)
      await Helpers.setUrlQuery(filters)
      return this.apiClient.get(`/clients?all=1`, {
        params
      })
    },
  },
})
